import { render, staticRenderFns } from "./V2WishlistList.vue?vue&type=template&id=73969982&scoped=true&"
import script from "./V2WishlistList.vue?vue&type=script&lang=js&"
export * from "./V2WishlistList.vue?vue&type=script&lang=js&"
import style0 from "./V2WishlistList.vue?vue&type=style&index=0&id=73969982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73969982",
  null
  
)

export default component.exports